// extracted by mini-css-extract-plugin
export default {"exclamation-mark":"PopupTitleDangerous_exclamation-mark__KRSpF"};